import SendTopup from "./SendTopup";

/**
 * Utilities & Bills — reuses the SendTopup form, filtered to the "bills"
 * catalog category so only utility / TV / bill-payment products from
 * DingConnect and Reloadly surface.
 *
 * The three dropdowns (country / operator / product) all query the
 * catalog endpoints with `category=bills`, so a purely-airtime carrier
 * (e.g. Digicel Haiti) never appears in the operator list here.
 */
export default function PayBills() {
  return (
    <SendTopup
      category="bills"
      pageTitle="Utilities & Bills"
      pageSubtitle="Payer les factures (électricité, eau, internet, TV…)."
    />
  );
}
